export const FONT_SIZE_STORAGE_KEY = 'sgi-font-size';

export const FONT_SIZE_MIN_PX = 10;
export const FONT_SIZE_MAX_PX = 20;
export const FONT_SIZE_DEFAULT_PX = 15;
export const FONT_SIZE_STEP_PX = 1;

/** Tamanho visual alvo do texto de interface (labels, inputs, body) com base média. */
export const FONT_SIZE_UI_TARGET_PX = 14.875;

/** Proporção em rem: 14.875px ÷ 15px — escala junto com o controle A−/Média/A+. */
export const FONT_SIZE_UI_REM_RATIO =
  FONT_SIZE_UI_TARGET_PX / FONT_SIZE_DEFAULT_PX;

/** Valores legados (presets antigos) para migração do localStorage. */
export const FONT_SIZE_LEGACY_PRESETS = {
  sm: 13,
  md: 15,
  lg: 16,
} as const;
